import { Box, Card, CardMedia, Chip, Tooltip, Typography } from '@mui/material'
import BiodiversityMap from '../../../../resources/images/biodevmap.png'
import { ReactComponent as areaCovered } from '../../../resources/images/areacovered.svg'
import {ReactComponent as cameraInstalled} from '../../../resources/images/camera.svg'
import {ReactComponent as audioDevices} from '../../../resources/images/audio.svg'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getCurrentProjectMergedFlat } from '../../../../utils/mergeData';


const BiodiversityDashboard = () => {
    const [projectSite, setProjectList] = useState([]);
    const [defaultProjectSite, setDefaultProjectList] = useState([]);
    const selectedProjectStr = localStorage.getItem('selectedProject');
    const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;
    const currentProject = getCurrentProjectMergedFlat(projectSite, defaultProjectSite, selectedProject?.project_name);

    return (
        <Box sx={{
            width: '100%',
            height: '100vh', // Full viewport height for the container
            overflow: 'hidden',
            backgroundColor: '#f5f5f5',
            p: 2
        }}>
            <Box className='bio-map'>
                <img src={BiodiversityMap} alt="map" className='bio-map-img' />
            </Box>
            <Box>
                <Box sx={{ mt: 1 }}>
                    <Typography sx={{ fontSize: "24px", fontWeight: 600, color: "#151E15" }}>{currentProject?.project_name || 'Project Title'}</Typography>
                </Box>


                <Box sx={{
                    display: 'flex',
                    overflowX: 'auto',
                    gap: 2,
                    p: 1,
                    '&::-webkit-scrollbar': {
                        height: '8px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#ccc',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f5f5f5',
                    }
                }}>
                    {currentProject?.sites?.map((site: any, index: any) => {
                        console.log('site', site)
                        return (
                            <Link to={`/biodiversity-analysis-detail`} style={{ textDecoration: 'none' }} key={index} state={site} onClick={() => localStorage.setItem('site', JSON.stringify(site))}>
                                <Card sx={{ display: 'flex', width: "400px", backgroundColor: "#151E15", borderRadius: 2, overflow: 'hidden', m: 1 }}>
                                    <Box sx={{ flex: 1 }}>
                                        <CardMedia
                                            component="img"
                                            sx={{ height: '100%', objectFit: 'cover' }}
                                            image={BiodiversityMap}
                                            alt="Site image"
                                        />
                                    </Box>

                                    <Box sx={{
                                        display: 'flex', flexDirection: 'column', padding: 2, gap: 1.5,
                                        flex: 1, overflow: 'auto', maxHeight: '200px', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' }
                                    }}>
                                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#fff", textAlign: 'center' }}>
                                            {site.site_name}
                                        </Typography>

                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
                                            {/* {stats.map(({ icon, label, amount }, index) => ( */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AreaCovered />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Area Covered'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{currentProject?.total_area}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Habitat Score'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.habitat_score}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<CameraInstalled />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Camera Installed'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.camera_installed}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Audio Devices'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.audio_devices}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AudioDevices />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Diversity MSA'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.msa}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Diversity Intactness'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.biodiversity_intactness}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AudioDevices />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Shanon Diversity'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.shanon_diversity}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Simpson Diversity'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.simpson_diversity}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AudioDevices />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Species Richness'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.species_richness}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Species Diversity'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.species_diversity}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AudioDevices />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Taxonomic'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.taxonomic_dissimilarity}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Habitat Health'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.habitat_health}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AudioDevices />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Habitat Spatial'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.habitat_spatial_structure}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Habitat Health'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.habitat_health}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AudioDevices />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Species Habitat'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.species_habitat_health}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Species Protection'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.species_protection_index}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}>
                                                {/* <Box sx={{ width: 20, height: 20, mb: 3 }}>{<AudioDevices />}</Box> */}
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Species Info'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.species_info_index}</Typography>
                                                </Box>
                                                <Box sx={{ ml: 3 }}>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 700 }}>{'Human Intrusion'}</Typography>
                                                    <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>{site.human_intrusion}</Typography>
                                                </Box>
                                            </Box>
                                            {/* ))} */}
                                        </Box>
                                    </Box>
                                </Card>
                            </Link>
                        )
                    })}
                </Box>
            </Box>
        </Box>
    )
}

export default BiodiversityDashboard